module.exports = __webpack_public_path__ + "static/media/login-img-firstpage.7d9595f4.png";